<template>
  <div>
    <router-view />
  </div>
</template>

<script>
import axios from "axios"; // 引入axios
import { getTemplateId } from "../request/api"; // 获取模板id
import { Process } from "../request/host"; // 获取环境变量
import router from '../router/index';
export default {
  data() {
    return {
      tempId: null
    };
  },
  components: {},
  created() {
    getTemplateId({}).then(res => {
      if (res.status == "SUCCESS") {
        let tempId = res.data.pageIndex.templateId;
        this.toRoute(tempId);
        sessionStorage.setItem("tempId", tempId); // 设置id
      } else {
        if (res.status == 'ERROR') {
          this.$alert('当前学校未开通二级域名，如有问题请联系客服。', 'fif智慧教学平台', {
            confirmButtonText: '确定',
            callback: action => {
              top.location.href = `${Process.env.VUE_APP_ENV}/iplat/html/index.html`;
            }
          });
        }
      }
    })
      .catch(err => {
        this.$message(err);
      });
  },
  methods: {
    //获取主机url
    getHostPath() {
      var curWwwPath = window.document.location.href;
      var pathName = window.document.location.pathname;
      var pos = curWwwPath.indexOf(pathName);
      var localhostPath = curWwwPath.substring(0, pos);
      return localhostPath;
    },
    toRoute(tempId) {
      const domain = this.getHostPath().split("//")[1].split(".")[0]; //获取二级域名
      if(domain.indexOf('sdu') != -1 && domain.indexOf('jcsdu') == -1){  //特殊定制页面
          location.href = 'https://ilearning.fifedu.com/course-library/#/index?shortName=sdu'; // 本地定制
          return
      }
      if(domain.indexOf('whut') != -1){  //特殊定制页面
          location.href = 'https://ilearning.fifedu.com/course-library/#/index?shortName=whut'; // 本地定制
          return
      }
      if(domain.indexOf('ccnu') != -1){  //特殊定制页面
          location.href = 'https://ilearning.fifedu.com/course-library/#/index?shortName=ccnu'; // 本地定制
          return
      }
      if(domain.indexOf('ynu') != -1){  //特殊定制页面
          location.href = 'https://ilearning.fifedu.com/course-library/#/index?shortName=ynu'; // 本地定制
          return
      }
      // if(domain.indexOf('nefu') != -1){  //特殊定制页面
      //     location.href = 'https://ilearning.fifedu.com/course-library/#/index?shortName=nefu'; // 本地定制
      //     return
      // }
      if(domain.indexOf('elearn') != -1){  //特殊定制页面
          location.href = 'https://sttp.fifedu.com/areaPortal-web/index?shortName=elearn'; // 本地定制
          return
      }
      switch (tempId) {
        case 4:
          this.$router.push({ path: "/first?v=5.2.6" });
          break;
        case 2:
          this.$router.push({ path: "/second?v=5.2.6" });
          break;
        case 3:
          this.$router.push({ path: "/thirdly?v=5.2.6" });
          break;
        case 5:
          this.$router.push({ path: "/fourth?v=5.2.6" });
          break;
        case 6:
          this.$router.push({ path: "/fifth?v=5.2.6" });
          break;
        case 1:
          location.href = "https://sttp.fifedu.com/courselibrary-web/index?shortName=" + domain; // 第六模板
          break;
        default:
          break;
      }
    },
  }
};
</script>
<style lang="less">
.el-icon-loading {
  color: #ddd !important;
  font-size: 38px;
}
</style>



// WEBPACK FOOTER //
// src/page/index.vue